import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { UserInfoService } from 'shared/src/services/user-info.service';

export const emailGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const userInfo = inject(UserInfoService);
  const router = inject(Router);

  if (userInfo.getEmail()) {
    return true;
  }

  return router.createUrlTree(['login'], {
    queryParams: {
      destination: state.url,
    },
  });
};
